"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _ProductIconContainer = _interopRequireDefault(require("../common/ProductIcon/ProductIconContainer"));
require("./BalanceItem.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var balanceItemClasses = (0, _cssClassesHelper.getBEMClasses)('balance-item');
var BalanceItemComponent = function BalanceItemComponent(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: balanceItemClasses('container')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: balanceItemClasses('group')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: balanceItemClasses('icon')
  }, /*#__PURE__*/_react["default"].createElement(_ProductIconContainer["default"], {
    iconFileName: props.balance.iconFileName,
    size: 24
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: balanceItemClasses('product')
  }, props.balance.Product + ' ' + props.balance.ProductFullName)), /*#__PURE__*/_react["default"].createElement("div", {
    className: balanceItemClasses('group')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: balanceItemClasses('position')
  }, props.balance.Amount)));
};
var _default = exports["default"] = BalanceItemComponent;